import { TRANSITIONS_WITH_EXTRACTED_DATA } from './resources/lottieTransitionsWithExtractedData';
import { createMigration } from './utils';

export function getAspectRatioForResolution(width: number, height: number) {
    if (width === 1920 && height === 1080) {
        return 'landscape';
    }
    if (width === 1080 && height === 1920) {
        return 'vertical';
    }
    if (width === 1080 && height === 1080) {
        return 'square';
    }
    throw new Error(`Unknown width/height: ${width}/${height}`);
}

export const migrationTo9_173 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const transitionName = map.get('transition');
            const width = map.getIn(['resolution', 'width']) as number;
            const height = map.getIn(['resolution', 'height']) as number;
            const aspectRatio = getAspectRatioForResolution(width, height);
            const transitionUrl = TRANSITIONS_WITH_EXTRACTED_DATA[transitionName]['transitionUrl'][aspectRatio];
            map.setIn(['customTransition', 'transitionUrl'], transitionUrl);
            const transitionDuration = TRANSITIONS_WITH_EXTRACTED_DATA[transitionName]['transitionDuration'];
            map.setIn(['customTransition', 'transitionDuration'], transitionDuration);

            // if we have a valid url and duration, then we should have extractedData
            if (transitionUrl && transitionDuration > 0) {
                const extractedData = TRANSITIONS_WITH_EXTRACTED_DATA[transitionName]['extractedData'];
                map.setIn(['customTransition', 'extractedData'], extractedData);
            }
        });
    },
});
